import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, ChangeDetectorRef, OnInit, signal } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DecimalInputDirective } from '@/directives/decimal-input.directive';

@Component({
  selector: 'app-tariffs-form',
  imports: [
    DecimalInputDirective,
    CommonModule,
    CustomModalComponent,
    ReactiveFormsModule,
    LoadingComponent,
  ],
  templateUrl: './tariffs-form.component.html',
  styleUrl: './tariffs-form.component.scss',
})
export class TariffsFormComponent implements OnInit {
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);
  public saveForm: FormGroup = new FormGroup({});

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getPetition();
  }

  createForm() {
    this.saveForm = new FormGroup({
      ticket_tariff: new FormControl(null),
      invoice_tariffs: new FormArray([])
    });
  }

  get tariffItems() {
    return this.saveForm.get('invoice_tariffs') as FormArray;
  }

  addTariffRow(data: any = { name: '', quotient: 0 }) {
    this.tariffItems.push(new FormGroup({
      id: new FormControl(data.id || null),
      name: new FormControl(data.name || ''),
      quotient: new FormControl(data.quotient || '', [Validators.required]),
    }));
  }

  removeTariffRow(index: number) {
    this.tariffItems.removeAt(index);
  }

  getPetition() {
    this.loading.set(true);
    this.apiService.getPetition(Urls.urls.companyTariffs).subscribe({
      next: (data: any) => {
        this.tariffItems.clear();

        if (data.invoice_tariffs && Array.isArray(data.invoice_tariffs)) {
          data.invoice_tariffs.forEach((item: any) => {
            const visualQuotient = item.quotient ? Math.round((parseFloat(item.quotient) - 1) * 100) : '';
            this.addTariffRow({ ...item, quotient: visualQuotient });
          });
        }

        const ticket_tariff = data.ticket_tariff ? Math.round((parseFloat(data.ticket_tariff) - 1) * 100) : '';

        this.saveForm.patchValue({
          ticket_tariff
        });

        this.loading.set(false)
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.loading.set(false);
        console.error('Error:', error);
      },
      complete: () => this.loading.set(false)
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);

      const formValue = { ...this.saveForm.value };

      const ticketTariffValue = parseFloat(formValue.ticket_tariff);
      const convertedTicketTariff = !isNaN(ticketTariffValue) ? (1 + ticketTariffValue / 100).toFixed(2) : null;

      const convertedInvoiceTariffs = formValue.invoice_tariffs.map((tariff: any) => {
        const quotientValue = parseFloat(tariff.quotient);
        return {
          ...tariff,
          quotient: !isNaN(quotientValue) ? (1 + quotientValue / 100).toFixed(2) : ''
        };
      });

      const payload = {
        ticket_tariff: convertedTicketTariff,
        invoice_tariffs: convertedInvoiceTariffs
      };

      let lastId = 0;

      payload.invoice_tariffs.map((tariff: any) => {
        if (tariff.id != null && lastId < tariff.id) {
          lastId = tariff.id
        }
      })

      payload.invoice_tariffs.map((tariff: any) => {
        if (tariff.id == null) {
          tariff.id = ++lastId;
        }
      })

      this.apiService.save(Urls.urls.companyTariffs, payload, 0).subscribe({
        next: (response: any) => {
          Utils.notification.success("Tarifa guardada")
          this.acceptFunction.emit(response);
          this.closeFunction.emit();
        },
        error: (error) => {
          this.saving.set(false);
          Utils.notification.alert(Utils.extractErrorMessage(error) || "Error al guardar la tarifa")
        },
        complete: () => this.saving.set(false)
      });
    } else {
      Utils.notification.alert("Debe completar todos los campos obligatorios")
    }
  }

  acceptFormFunction() { this.saveEntity(); }
  closeFormFunction() { this.closeFunction.emit(); }
}